export default __webpack_public_path__ + "static/media/phone-keyboard.aebf43c6.png";